export function TagId(tag) {
    if (typeof tag === 'string') {
        return tag;
    }
    return tag.id;
}
export function TagName(tag, tagInfos) {
    if (typeof tag === 'string') {
        return TagNameFromId(tag, tagInfos);
    }
    // if tag is tag info, then use the name
    if ('name' in tag && tag.name) {
        return tag.name;
    }
    if (tag.id) {
        return TagNameFromId(tag.id, tagInfos);
    }
    return undefined;
}
export function TagNameFromId(tag, tagInfos) {
    const info = tagInfos.find(t => t.id === tag);
    if (info) {
        return info.name;
    }
    let result = tag;
    if (tag.includes(':')) {
        result = tag.split(':')[1];
    }
    const parts = result.split('_');
    for (let i = 0; i < parts.length; i++) {
        parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
    }
    return parts.join(' ');
}
export function toggleTag(selectedTags, tag) {
    const wasSelected = selectedTags.find(t => t.id === tag.id);
    if (wasSelected) {
        return selectedTags.filter(t => t.id !== tag.id);
    }
    function isConflictingTag(t) {
        if (tag.group && t.group === tag.group) {
            // only one tag from the group can be selected
            return false;
        }
        return true;
    }
    const result = selectedTags.filter(t => !isConflictingTag(t));
    result.push(tag);
    return result;
}
export function displayInList(tag, selectedTags) {
    // by default all tags are displayed
    return true;
}
export function sortTags(tags) {
    let groupedTags = tags.filter(t => t && t.group && t.group.length > 0);
    const otherTags = tags.filter(t => t && !t.group);
    groupedTags = groupedTags.sort((a, b) => {
        if (a.group && b.group) {
            const groupComparison = a.group.localeCompare(b.group);
            if (groupComparison !== 0) {
                return groupComparison;
            }
        }
        return a.id.localeCompare(b.id);
    });
    return [...groupedTags, ...otherTags];
}
export function parseTagId(tagId) {
    if (!tagId) {
        return undefined;
    }
    if (tagId.includes(':')) {
        return parseTagIdWithGroup(tagId);
    }
    return {
        id: tagId,
        visibleName: TagNameFromId(tagId, []),
    };
}
function parseTagIdWithGroup(tagId) {
    const parts = tagId.split(':');
    return {
        id: tagId,
        visibleName: TagNameFromId(parts[1], []),
        group: parts[0],
    };
}
